import React, { useCallback, useEffect } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { useHistory } from 'react-router-dom';
import { publish } from '@jutro/events';
import { WMICButton } from 'wmic-components-platform-react';
import { WMICTopics } from 'wmic-portals-utils-js';

import { phoneNumber } from '../utils/WMICEnrollmentConstants';
import { translateRichText } from '../utils/WMICRichTextUtil';

import metadata from './ForgotEmailPage.metadata.json5';
import messages from './ForgotEmailPage.messages';

function ForgotEmailPage(props) {

    const translator = useTranslator();
    const history = useHistory();

    const saveForm = useCallback(() => {
        publish(WMICTopics.CTA_CLICK, {
            channel: 'my account',
            cta: 'my account:account maintenance:recovery:forgot email-back to log in',
            page: 'my account:account maintenance:recovery:forgot email',
            subchannel1: 'account maintenance',
            subchannel2: 'recovery',
            sessionid: sessionStorage.getItem('X_GWRE_SESSION') || '',
            state: (window.wins_data_layer?.state || '').toString().toLowerCase()
        });

        history.push('/');
    }, [history]);

    useEffect(() => {
        publish(WMICTopics.ROUTE_CHANGED, {
            channel: 'my account',
            page: 'my account:account maintenance:recovery:forgot email',
            subchannel1: 'account maintenance',
            subchannel2: 'recovery',
            sessionid: sessionStorage.getItem('X_GWRE_SESSION') || '',
            state: (window.wins_data_layer?.state || '').toString().toLowerCase(),
            route_view_mode: 'back_only'
        });
    }, []);

    const overrideProps = {
        pageDescription: {
            content: translateRichText(translator(messages.forgotEmailDescription, {
                phoneNumber: phoneNumber.FORMATTED,
                phoneNumberRaw: phoneNumber.RAW
            }))
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            saveForm: saveForm
        },
        resolveComponentMap: {
            WMICButton
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

export default ForgotEmailPage;